module.exports = __webpack_public_path__ + "img/default_headImg.70e776d9.png";